<div class="add-modal-container">
  <div mat-dialog-title class="title-header">ADD {{title}}</div>
  <div mat-dialog-content>
    <form [formGroup]="currentForm" (ngSubmit)="onSave($event)">
      @if (this.data.modalType==AddEquityInstallmentMode.INSTALLMENT) {
        <div class="row">
          <div class="col-md-4">
            Installment Number
          </div>
          <div class="col-md-4">
            Installment Amount
          </div>
          <div class="col-md-4">
            Original Commitment Date
          </div>
        </div>
      }
      @if (this.data.modalType==AddEquityInstallmentMode.INSTALLMENT) {
        <div class="row">
          <div class="col-md-4">
            <mat-form-field>
              <input type="number" matInput formControlName="installment_number" name="installment_number">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <input matInput type="number"  formControlName="installment_amount"  name="installment_amount">
              <mat-error>Installment amount required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <input matInput formControlName="original_commitment_date" name ="original_commitment_date" type="text" [matDatepicker]="datePicker">
              <mat-datepicker-toggle matIconPrefix [for]="datePicker"></mat-datepicker-toggle>
              <mat-datepicker #datePicker></mat-datepicker>
              <mat-error>Original Commitment Date required</mat-error>
            </mat-form-field>
          </div>
        </div>
      }
      @if (this.data.modalType==AddEquityInstallmentMode.CONDITION) {
        <div class="row">
          <div class="col">
            Condition Name
          </div>
          <div class="col">
            <div class="row">
              <mat-form-field>
                <textarea matInput formControlName="name" type="text"></textarea>
                <mat-error>Must include name</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col">
            Condition Nickname
          </div>
          <div class="col">
            <div class="row">
              <mat-form-field>
                <textarea matInput formControlName="nickname" type="text"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
      @if (this.data.modalType==AddEquityInstallmentMode.CONDITION) {
        <div class="row">
          <div>Notes</div>
          <mat-form-field>
            <textarea matInput formControlName="notes" type="text"></textarea>
          </mat-form-field>
        </div>
      }
      @if (data.modalType == AddEquityInstallmentMode.APPROVAL) {
        <div class="row">
          <mat-form-field>
            <mat-label>Approval Type</mat-label>
            <mat-select formControlName="approval_type">
              @for (type of data.approvalTypes; track type) {
                <mat-option [value]="type.id">{{type.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="row">
        <button mat-raised-button type="submit" class="save-button">SAVE</button>
        <button mat-raised-button (click)="close($event)" class="cancel-button">Cancel</button>
      </div>
    </form>
  </div>
</div>
